
import { mapState, mapActions, mapGetters } from "vuex";
import bulkEditPriceConfiguration from "./bulk-edit-price-configuration.vue";
const CONFIG = {
  isRecommended: false,
  dish_type: "",
  itemPrice: {},
  packingCharge: {},
  selectedCategory: null,
  selectedSubcategory: null,
  selectedTags: [],
  selectedPrinter: null,
  selectedTaxes: [],
  selectedChannels: [],
  selectedRestaurants: []
};
export default {
  components: { bulkEditPriceConfiguration },
  data() {
    return {
      config: {},
      localSelectedItems: [],
      hasConfigChange: false
    };
  },

  watch: {
    config: {
      handler(val) {
        this.hasConfigChange = JSON.stringify(val) !== JSON.stringify(CONFIG);
      },
      deep: true
    }
  },
  computed: {
    ...mapState("menu", [
      "menuItems",
      "categories",
      "taxes",
      "tags",
      "menuBulkEditSelection"
    ]),
    ...mapState("restaurant", ["printers", "locationDetails"]),
    ...mapGetters("restaurant", ["getLocationChannels", "hasMultipleBrands"]),
    hasSubCategory() {
      return (
        this.selectedCategory &&
        this.selectedCategory.subcategories &&
        this.selectedCategory.subcategories.length
      );
    }
  },
  beforeMount() {
    this.initConfig();
  },
  methods: {
    initConfig() {
      this.config = { ...CONFIG };
    },
    toggleSelectAllAvailableChannels() {
      this.config.selectedChannels =
        this.config.selectedChannels.length == this.getLocationChannels.length
          ? []
          : this.getLocationChannels.map((el) => {
              return el.name;
            });
    },
    getPriceValue(config, val) {
      let amt = 0;
      switch (config.config) {
        case "fixed-value":
          amt = config.value;
          break;
        case "increment-amount":
          amt = val + config.value;
          break;
        case "decrement-amount":
          amt = val - config.value;
          break;
        case "increment-percentage":
          amt = val + (val * config.value) / 100;
          break;
        case "fixed-value":
          amt = val - (val * config.value) / 100;
          break;

        default:
          amt = val;
          break;
      }
      if (amt < 0) amt = 0;
      return Math.round(amt * 100) / 100;
    },
    save() {
      let items = JSON.parse(
        JSON.stringify(
          this.menuItems.filter((el) =>
            this.menuBulkEditSelection.includes(el.id)
          )
        )
      );
      items.forEach((item, index) => {
        items[index].recommended_item = this.config.isRecommended;
        if (this.config.dish_type) {
          items[index].dish_type = [this.config.dish_type];
        }
        if (this.config.itemPrice?.config) {
          items[index].item_price = this.getPriceValue(
            this.config.itemPrice,
            items[index].item_price
          );
        }
        if (this.config.packingCharge?.config) {
          items[index].item_price = this.getPriceValue(
            this.config.itemPrice,
            items[index].item_price
          );
        }
        if (this.config.selectedCategory) {
          items[index].category_id = this.config.selectedCategory;
        }
        if (this.config.selectedSubcategory) {
          items[index].sub_category_id = this.config.selectedSubcategory;
        }
        if (this.config.selectedTags?.length) {
          items[index].tags = this.config.selectedTags;
        }
        if (this.config.selectedPrinter) {
          items[index].printer_id = this.config.selectedPrinter;
        }
        if (this.config.selectedTaxes?.length) {
          items[index].zomato_tax_id = this.config.selectedTaxes;
        }
        if (this.config.selectedChannels?.length) {
          items[index].channels = this.config.selectedChannels;
        }
        if (this.config.selectedRestaurants?.length) {
          items[index].restaurant_ids = this.config.selectedRestaurants;
        }
      });
      console.log(items);
    }
  }
};
